<script setup>
const props = defineProps({
  disabledText: {
    type: String,
    default: null,
  },
});

</script>

<template>
  <div class="select-option">
    <div
      v-if="props.disabledText"
      class="select-option__banner sdds-banner sdds-banner-info el-margin-bottom-8"
    >
      <div class="sdds-banner-body">
        <div class="sdds-banner-subheader">
          {{ $i18n(props.disabledText) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  h4 { margin: 0 }
  p { margin: 0 }

  .select-option {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 0 1 30em;
    min-width: 15em;
    -webkit-transition: border-color 0.2s ease-out;
    -moz-transition: border-color 0.2s ease-out;
    -ms-transition: border-color 0.2s ease-out;
    -o-transition: border-color 0.2s ease-out;
    transition: border-color 0.2s ease-out;
  }
  .select-option__banner {
    border-radius: 1rem;
  }
  .select-option.package { max-width: 40em; }

  @media only screen and (max-width: 1000px) {
    .select-option {
      flex-shrink: 0;
      min-width: 300px;
      scroll-snap-align: center;
    }
    .select-option.package {
      max-width: 90vw;
    }
  }

  @media only screen and (max-width: 500px) {
    .select-option {
      max-width: 80vw;
    }
    .package > .select-option {
      min-width: 60vw;
      max-width: 60vw;
    }
  }

</style>
